/* import __COLOCATED_TEMPLATE__ from './more-actions-menu-trigger.hbs'; */
import Component from '@ember/component';

/**
This component renders a div representing the trigger to open a context menu.
It is often used as the trigger in dropdowns (using [sq-dropdown](/components/glass/sq-dropdown.html)).

```example
@title Example

@hbs
<div style="padding: 20px 0;">
  <MoreActionsMenuTrigger />
</div>
```

```example
@title Example in Dropdown
@description click `...` to see the dropdown's popover.
@hbs
<div style="padding: 20px 0;">
{{#sq-dropdown class="item-list-more-action-dropdown" as |dropdown|}}
  {{#dropdown.trigger}}
    <MoreActionsMenuTrigger />
  {{/dropdown.trigger}}
  {{#dropdown.popover class="popover-list popover--fly-down"}}
    <div class="popover-list__item">this is a popover</div>
  {{/dropdown.popover}}
{{/sq-dropdown}}
</div>
```
*/

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  classNames: ['more-actions-menu__trigger'],
  click() {
    this.triggerAction();
  }
});